<template>
  <div>
    <v-card class="my-5">
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="2" class="text-h5 font-weight-bold ma-5">
          Hi, Kiran
        </v-col>
        <v-spacer></v-spacer>
        <v-col class="pa-0" cols="6"  xs="6" sm="3" md="1" align-self="center">
          <div class="text-center">
              <span class="font-weight-black text-h5">4</span>
            <p class="text-body-2 deep-purple--text font-weight-bold" style="cursor: pointer" @click="viewProfile('#governance')">Governance</p>
          </div>
        </v-col>
        <v-col class="pa-0" cols="6" xs="6" sm="3" md="1" align-self="center">
          <div class="text-center">
              <span class="font-weight-black text-h5">21/50</span>
            <p class="text-body-2 deep-purple--text font-weight-bold" style="cursor: pointer" @click="viewProfile('#tokens')">Tokens</p>
          </div>
        </v-col>
        <v-col class="pa-0" cols="6" xs="6" sm="3" md="1" align-self="center">
          <div class="text-center">
              <span class="font-weight-black text-h5">6</span>
            <p class="text-body-2 deep-purple--text font-weight-bold">Voted</p>
          </div>
        </v-col>
        <v-col class="pa-0" cols="6" xs="6" sm="3" md="1" align-self="center">
          <div class="text-center">
              <span class="font-weight-black text-h5">8</span>
            <p class="text-body-2 deep-purple--text font-weight-bold">Invested</p>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <v-row>
      <v-col>
        <v-card>
          <v-app-bar elevation="0">
            <v-toolbar-title class="text-h6 pl-0"> Top Projects </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </v-app-bar>
          <v-list three-line>
            <template v-for="(item, index) in topItems">
              <v-subheader
                v-if="item.header"
                :key="item.header"
                v-text="item.header"
              ></v-subheader>

              <v-divider
                v-else-if="item.divider"
                :key="index"
                :inset="item.inset"
              ></v-divider>

              <v-list-item v-if="item.title" :key="item.title">
                <v-list-item-avatar>
                  <v-img v-if="item.avatar" :src="item.avatar"></v-img>
                  <v-icon x-large v-else>mdi-account-circle</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title v-html="item.title"></v-list-item-title>
                  <v-list-item-subtitle
                    v-html="item.subtitle"
                  ></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <!-- <v-btn>View</v-btn> -->
                  <v-btn text color="deep-purple" small class="font-weight-bold" @click="viewProject(1)">View More</v-btn>
                </v-list-item-action>
              </v-list-item>
            </template>
            <v-card-actions>
              <v-spacer />
              <v-btn>View All</v-btn>
            </v-card-actions>
          </v-list>
        </v-card>
      </v-col>
      <v-col>
        <v-card>
          <v-app-bar elevation="0">
            <v-toolbar-title class="text-h6 pl-0">
              Trending Projects
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </v-app-bar>
          <v-list three-line>
            <template v-for="(item, index) in trendingItems">
              <v-subheader
                v-if="item.header"
                :key="item.header"
                v-text="item.header"
              ></v-subheader>

              <v-divider
                v-else-if="item.divider"
                :key="index"
                :inset="item.inset"
              ></v-divider>

              <v-list-item v-if="item.title" :key="item.title">
                <v-list-item-avatar>
                  <v-img v-if="item.avatar" :src="item.avatar"></v-img>
                  <v-icon x-large v-else>mdi-account-circle</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title v-html="item.title"></v-list-item-title>
                  <v-list-item-subtitle
                    v-html="item.subtitle"
                  ></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon> <v-icon>mdi-thumb-up-outline</v-icon></v-btn>
                </v-list-item-action>
                <v-list-item-action>
                  <v-btn text small color="deep-purple" class="font-weight-bold" @click="viewProject(2)">View More</v-btn>
                </v-list-item-action>
              </v-list-item>
            </template>
            <v-card-actions>
              <v-spacer />
              <v-btn>View All</v-btn>
            </v-card-actions>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="text-h5 font-weight-bold my-4">
        PROJECTS
      </v-col>
    </v-row>
    <v-sheet
      class="mx-auto"
    >
      <v-slide-group
        v-model="model"
        class="pa-4"
        center-active
        show-arrows
      >
      <template v-slot:prev="{ on, attrs }" >
        <v-btn small fab color="deep-purple" v-bind="attrs" v-on="on" class="mr-5"
          ><v-icon color="white">mdi-arrow-left</v-icon></v-btn
        >
      </template>
      <template v-slot:next="{ on, attrs }">
        <v-btn small fab color="deep-purple" v-bind="attrs" v-on="on"
          ><v-icon color="white">mdi-arrow-right</v-icon></v-btn
        >
      </template>
        <v-slide-item
          v-for="(item, index) in projects" :key="index"
          v-slot="{ toggle }"
        >
          <v-card
            class="ma-4"
            elevation="4"
            @click="toggle"
            height="250"
            min-width="150"
            max-width="500"
          >
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="text-h6 mb-1">
                  {{item.title}}
                </v-list-item-title>
                <v-list-item-subtitle>{{item.subtitle}}</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar
                rounded
                size="100"
                color="grey"
              ></v-list-item-avatar>
            </v-list-item>

              <v-list-item>
              <span class="grey--text mr-3">Team name</span>
               <span class="font-weight-bold">{{item.teamName}}</span>
              </v-list-item>
            <v-card-actions>
              <v-spacer />
              <v-btn text color="deep-purple" class="font-weight-bold" @click="viewProject(2)">View More</v-btn>
            </v-card-actions>
          </v-card>
        </v-slide-item>
      </v-slide-group>
    </v-sheet>
  </div>
</template>

<script>
export default {
  data() {
    return {
      model: null,
      topItems: [
        {
          title: "FINVOTE",
          subtitle: "A web page to show case all the hacka ideas. Share ideas accross the organisation",
        },
        { divider: true },
        {
          title: "Weather forecasting system",
          subtitle: "Weather forecasting systems use a combination of science and technology to make accurate predictions on weather conditions of a particular location at a particular time",
        },
      ],
      trendingItems: [
        {
          title: "Bug tracker",
          subtitle: "This is a bug tracking application that helps identify and track bugs in projects or systems",
        },
        { divider: true },
        {
          title: "e-Learning platform",
          subtitle: "In this project, you will build a sharable e-learning platform using cloud computing infrastructure for online learning",
        },
      ],
      projects: [
        {
          title: "FINVOTE",
          subtitle: "A web page to show case all the hacka ideas. Share ideas accross the organisation",
          teamName: 'Pixie Normous',
        },
        {
          title: "Weather forecasting system",
          subtitle: "Weather forecasting systems use a combination of science and technology to make accurate predictions on weather conditions of a particular location at a particular time",
          teamName: 'Raven Raiders',
        },
        {
          title: "Credit card fraud detection",
          subtitle: "This credit card fraud detection system studies and analyzes user behavior patterns and uses location scanning techniques to identify any unusual patterns",
          teamName: 'Master Spinners',
        },
        {
          title: "AI shopping system",
          subtitle: "As the name suggests, the AI multi-agent shopping system is a shopping assistant, more like a recommendation engine",
          teamName: 'Basic Boys',
        },
        {
          title: "Bug tracker",
          subtitle: "This is a bug tracking application that helps identify and track bugs in projects or systems",
          teamName: 'Nans Lads',
        },
        {
          title: "e-Learning platform",
          subtitle: "In this project, you will build a sharable e-learning platform using cloud computing infrastructure for online learning",
          teamName: 'Debuggers',
        },
        {
          title: "Smart health prediction system",
          subtitle: "An intelligent health prediction system can transform the way people take charge of their health while also connecting them to the nearest healthcare providers immediately",
          teamName: 'Outliers',
        },
        {
          title: "Sentiment analysis for product rating",
          subtitle: "This project aims to develop a sentiment analysis system for product rating. It is an e-commerce web application",
          teamName: 'Charging Hulks',
        },

      ]
    };
  },
  methods: {
    viewProject(projectId) {
      this.$router.push({name: 'Project', params: {projectId}})
    },
    viewProfile(section) {
      this.$router.push({name: 'Profile', params: {section}})
    }
  }
};
</script>
